import AboutService from '../services/about'
import toast from '../toast';

export default {
    namespaced: true,
    state: {
        staffs: [],
    },
    mutations: {
        GET_STAFFS(state, data) {
            state.staffs = data
        },
    },
        actions: {
            // eslint-disable-next-line no-unused-vars
            allStaff({ commit }, query) {
                return AboutService.index(query)
                    .then(response => {
                        commit('GET_STAFFS', response.data)
                        return Promise.resolve(response)
                    })
                    .catch(error => {
                        toast(error.response.data.message, 'error')
                        return Promise.reject(error.response.data.message)
                    })
            }
        }
}
